import { createContext, useContext } from 'react'

/**
 * Chave em `location.state` ao abrir detalhes a partir da lista (dados já vindos de `api.reports.list`).
 * Ver `Reports.jsx`: passa `{ name, cnpj }` de `row.Address.Client` sem nova consulta só para o banner.
 */
export const REPORT_SCOPE_CLIENT_STATE_KEY = 'reportScopeClient'

/** Setter injected by ReportScopeLayout; children call this when report/follow-up payloads load. */
export const ReportCompanyOutletContext = createContext(() => {})

export function useReportCompanySync() {
    return useContext(ReportCompanyOutletContext)
}
